import React, { useEffect } from 'react';
import EnterpriceBanner from './EnterpriceBanner';
import Ditalcards from './Ditalcards';
import DigitalmobilityTabscards from './DigitalmobilityTabscards';
import Digitalcapabilityhovercards from './Digitalcapabilityhovercards';
import Automotivemobilitecards from './Automotivemobilitecards';
// import Automotivemobilitecards from './Automotivemobilitecards';
import AutomobilityTabs from './AutomobilityTabs';
import Automobilityverticaltabs from './Automobilityverticaltabs';
import AerospaceIntroductioncards from './AerospaceIntroductioncards';
const EnterpriceprivateNetworks = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
          // Scroll to the top of the page when the component mounts
 
  return (
    <div style={{background:'#fff'}}>
        <EnterpriceBanner />
        {/* <GeospatialBanner /> */}
        {/* <CommunicationBanner /> */}
         {/* <BannersAero/> */}
         <Automotivemobilitecards />
         <Ditalcards />
        <Digitalcapabilityhovercards />
   
           <DigitalmobilityTabscards />
         {/* <IncrementCounter /> */}
          {/* <Stack /> */}
        {/* <AboutCompany/>
        <OurCommitments/>
        <OurLeadership/> */}
        {/* { <OurLeadership/> } */}
        {/* { <Testimonials/> } */}



        <style>
          {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
        </style>
    </div>
  )
}

export default EnterpriceprivateNetworks;